import React, { useState } from 'react';
import { motion } from 'framer-motion';

export const LandingPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSignup = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // TODO: Implement actual signup API call
    setTimeout(() => {
      setIsSubmitting(false);
      alert('Obrigado! Entraremos em contato em breve.');
    }, 1500);
  };

  return (
    <div className="landing-page bg-gradient-to-br from-green-50 to-blue-50">
      {/* Hero Section */}
      <div className="bg-white shadow-sm">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center">
                <span className="text-white text-xl font-bold">Q</span>
              </div>
              <h1 className="text-2xl font-bold text-gray-900">QRSP</h1>
            </div>
            <div className="flex items-center space-x-4">
              <a href="/app" className="text-gray-600 hover:text-gray-900 transition-colors">
                Entrar no App
              </a>
              <a href="/demo" className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors">
                Ver Demo
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Hero */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6">
              Ganhe <span className="text-green-600">renda extra</span> como motorista em São Paulo
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Conecte-se com estabelecimentos locais, ofereça cupons de desconto aos seus passageiros 
              e receba <strong>15% de comissão</strong> em cada resgate. Pagamentos via PIX toda sexta-feira.
            </p>
            
            {/* Key Benefits */}
            <div className="space-y-4 mb-8">
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 text-sm">✓</span>
                </div>
                <span className="text-gray-700"><strong>R$ 500-2000/mês</strong> de renda adicional</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 text-sm">✓</span>
                </div>
                <span className="text-gray-700"><strong>PIX automático</strong> toda sexta-feira</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 text-sm">✓</span>
                </div>
                <span className="text-gray-700"><strong>App grátis</strong> - funciona no seu celular</span>
              </div>
            </div>

            {/* CTA Form */}
            <form onSubmit={handleSignup} className="bg-white p-6 rounded-xl shadow-lg">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                🚗 Cadastre-se grátis agora
              </h3>
              <div className="space-y-4">
                <div>
                  <input
                    type="tel"
                    placeholder="Seu WhatsApp: (11) 99999-9999"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    required
                  />
                </div>
                <div>
                  <input
                    type="email"
                    placeholder="Seu email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    required
                  />
                </div>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors disabled:opacity-50"
                >
                  {isSubmitting ? 'Enviando...' : 'Quero começar a ganhar! 💰'}
                </button>
              </div>
              <p className="text-xs text-gray-500 mt-3 text-center">
                Grátis para sempre. Comissões pagas via PIX.
              </p>
            </form>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            {/* Phone Mockup */}
            <div className="relative mx-auto w-80 h-96 bg-gray-900 rounded-3xl p-2 shadow-2xl">
              <div className="w-full h-full bg-white rounded-2xl overflow-hidden relative">
                {/* Status Bar */}
                <div className="bg-gray-100 h-8 flex items-center justify-between px-4 text-xs">
                  <span>9:41</span>
                  <span>📶 📶 📶</span>
                </div>
                
                {/* App Screenshot */}
                <div className="p-4 h-full bg-gradient-to-b from-green-50 to-white">
                  <div className="text-center mb-6">
                    <h2 className="text-lg font-bold text-gray-900 mb-2">🎯 Meus Ganhos</h2>
                    <div className="text-3xl font-bold text-green-600">R$ 1.247,50</div>
                    <p className="text-sm text-gray-600">Este mês</p>
                  </div>
                  
                  <div className="space-y-3">
                    <div className="bg-white p-3 rounded-lg shadow-sm">
                      <div className="flex justify-between items-center">
                        <div>
                          <p className="font-medium text-sm">Pizza 30% OFF</p>
                          <p className="text-xs text-gray-500">Pizzaria do João</p>
                        </div>
                        <div className="text-green-600 font-bold">+R$ 18,50</div>
                      </div>
                    </div>
                    
                    <div className="bg-white p-3 rounded-lg shadow-sm">
                      <div className="flex justify-between items-center">
                        <div>
                          <p className="font-medium text-sm">Café Grátis</p>
                          <p className="text-xs text-gray-500">Café da Esquina</p>
                        </div>
                        <div className="text-green-600 font-bold">+R$ 12,00</div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="absolute bottom-4 left-4 right-4">
                    <div className="bg-green-600 text-white text-center py-2 rounded-lg">
                      💰 PIX na sexta-feira
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* How It Works */}
      <div className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Como funciona?
            </h2>
            <p className="text-xl text-gray-600">
              Simples, rápido e lucrativo
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center"
            >
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🏪</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">1. Recrute estabelecimentos</h3>
              <p className="text-gray-600">
                Visite restaurantes, farmácias e lojas perto das suas corridas. 
                Convide-os para oferecer descontos aos seus passageiros.
              </p>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-center"
            >
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">📱</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">2. Gere códigos QR</h3>
              <p className="text-gray-600">
                Durante as corridas, use o app para gerar QR codes de desconto 
                para seus passageiros. Cada código dura 5 minutos.
              </p>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="text-center"
            >
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">💰</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">3. Receba 15% de comissão</h3>
              <p className="text-gray-600">
                Quando o passageiro usar o cupom, você ganha 15% de comissão. 
                Pagamento automático via PIX toda sexta-feira.
              </p>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Social Proof */}
      <div className="bg-gray-50 py-16">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Motoristas já estão ganhando
            </h2>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-xl shadow-sm">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 font-bold">CS</span>
                </div>
                <div className="ml-3">
                  <h4 className="font-semibold text-gray-900">Carlos Silva</h4>
                  <p className="text-sm text-gray-600">Vila Madalena</p>
                </div>
              </div>
              <p className="text-gray-700 mb-3">
                "Já ganho R$ 800 extras por mês só oferecendo cupons pros meus passageiros. 
                A pizzaria da região virou parceira!"
              </p>
              <div className="text-green-600 font-bold">R$ 847,50 este mês</div>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-sm">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 font-bold">MR</span>
                </div>
                <div className="ml-3">
                  <h4 className="font-semibold text-gray-900">Maria Rosa</h4>
                  <p className="text-sm text-gray-600">Consolação</p>
                </div>
              </div>
              <p className="text-gray-700 mb-3">
                "Recrute 3 estabelecimentos e já tô recebendo PIX toda semana. 
                Passageiros adoram os descontos!"
              </p>
              <div className="text-green-600 font-bold">R$ 520,75 este mês</div>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-sm">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 font-bold">JP</span>
                </div>
                <div className="ml-3">
                  <h4 className="font-semibold text-gray-900">João Paulo</h4>
                  <p className="text-sm text-gray-600">Ipiranga</p>
                </div>
              </div>
              <p className="text-gray-700 mb-3">
                "Comecei semana passada e já recebi meu primeiro PIX! 
                R$ 127 pela primeira semana."
              </p>
              <div className="text-green-600 font-bold">R$ 127,25 esta semana</div>
            </div>
          </div>
        </div>
      </div>

      {/* Final CTA */}
      <div className="bg-green-600 py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Pronto para ganhar renda extra?
          </h2>
          <p className="text-xl text-green-100 mb-8">
            Junte-se aos motoristas que já estão recebendo PIX toda sexta-feira
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#signup"
              className="bg-white text-green-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors inline-flex items-center justify-center"
            >
              📱 Cadastrar grátis agora
            </a>
            <a
              href="/demo"
              className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-green-600 transition-colors inline-flex items-center justify-center"
            >
              🎬 Ver como funciona
            </a>
          </div>
          <p className="text-green-100 text-sm mt-4">
            Sem taxas de adesão • PIX automático • Suporte via WhatsApp
          </p>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-900 text-white py-12">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-8 h-8 bg-green-600 rounded-lg flex items-center justify-center">
                  <span className="text-white text-sm font-bold">Q</span>
                </div>
                <h3 className="text-xl font-bold">QRSP</h3>
              </div>
              <p className="text-gray-400 text-sm">
                Plataforma de cupons QR para motoristas de aplicativo em São Paulo.
              </p>
            </div>
            
            <div>
              <h4 className="font-semibold mb-3">Produto</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><a href="/demo" className="hover:text-white">Demo</a></li>
                <li><a href="/app" className="hover:text-white">App</a></li>
                <li><a href="#" className="hover:text-white">Como funciona</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-3">Suporte</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><a href="#" className="hover:text-white">WhatsApp</a></li>
                <li><a href="#" className="hover:text-white">FAQ</a></li>
                <li><a href="#" className="hover:text-white">Termos de uso</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-3">São Paulo</h4>
              <p className="text-sm text-gray-400">
                Feito especialmente para motoristas de aplicativo na maior cidade do Brasil.
              </p>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center">
            <p className="text-gray-400 text-sm">
              © 2024 QRSP. Todos os direitos reservados. Feito com ❤️ em São Paulo.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};